import { HttpInterceptorFn } from '@angular/common/http';
import { v7 as uuid } from 'uuid';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req: any, next: any) => {
  const _uuid = uuid();

    const isMultiPart = req.body instanceof FormData;
    if (!isMultiPart) {

      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/json').set('x-request-id', _uuid)
      });
    } else {

      req = req.clone({
        headers: req.headers.set('x-request-id', _uuid)
      });
    }

    return next(req);
}